import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-bottom: 1px solid var(--color-sw-10);
  background: var(--color-g-3);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  @media screen and ${breakpoint.s} {
    padding: 16px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`
const Title = styled.div`
  font: var(--typography-16-20-semibold);
  color: var(--color-night);
`
const Subtitle = styled.div`
  font: var(--typography-14-20-regular);
  color: var(--color-night);
`

const Description: FC = () => {
  const { t } = useTranslation()

  return (
    <DescriptionWrapper>
      <Title>{t('dialogs.recognizeWine.desc.title')}</Title>
      <Subtitle>{t('dialogs.recognizeWine.desc.subtitle')}</Subtitle>
    </DescriptionWrapper>
  )
}

export default Description
